export enum EmbedResizeMode {
    Default = 0,
    ScaleToFit = 1,
    ScaleToFill = 2
}
